import { Component, OnInit, Input, EventEmitter } from '@angular/core';
import { MdDialog, MdDialogRef } from '@angular/material';
import { Invite } from '../../models/invite';
import { InviteService } from '../../services/invite.service';
import { MessageBoxDialog } from '../message-box/message-box.component';
import { Router } from '@angular/router';
import { UploadOutput, UploadInput, UploadFile, humanizeBytes } from 'ngx-uploader';
import {environment} from '../../../environments/environment';
import { AuthService } from '../../services/auth.service';
import { MessageBoxInviteDialog } from '../message-box-invite/message-box-invite.component';
import { PaymentDialogComponent } from '../payment-dialog/payment-dialog.component';

@Component({
  selector: 'app-invite',
  templateUrl: './invite.component.html',
  styleUrls: ['./invite.component.css']
})
export class InviteComponent implements OnInit {
  publicating: boolean = false;
  @Input() Job;
  @Input() nameComponent;
  createInvite: boolean = true;
  listInvitations: any = [];
  errorMessage: string;
  jobId: string;
  jobReq: number;
  visibleInviteOneByOne: boolean;
  visibleInviteUploadFile: boolean;
  firstname: string;
  lastname: string;
  email: string;
  mobile: string;
  idnumber: string;

  // Upload File
  formData: FormData;
  files: UploadFile[];
  uploadInput: EventEmitter<UploadInput>;
  humanizeBytes: Function;
  dragOver: boolean;

  emailRegex: any = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  validEmail () {
    if (this.email != undefined && this.email != '') {
      let a = this.emailRegex.test(this.email);
      return a;
    }
    return true;
  }

  constructor(public dialogRef: MdDialogRef<InviteComponent>, private dialog: MdDialog, private router: Router, private inviteService:InviteService, private auth:AuthService) {
    // UploadFile
    this.files = []; // local uploading files array
    this.uploadInput = new EventEmitter<UploadInput>(); // input events, we use this to emit data to ngx-uploader
    this.humanizeBytes = humanizeBytes;
  }

  ngOnInit() {
    this.jobId = this.Job.id;
    this.jobReq = this.Job.requisition_id;
    console.log (this.nameComponent + ':' + this.jobId);
    this.visibleInviteOneByOne = true;
    this.visibleInviteUploadFile = false;
  }

  showInviteSearchCandidates () {
    this.dialogRef.close('yes');
    this.router.navigate(['/pages/candidates_map/']);
  }

  showInviteOneByOne () {
    console.log('showInviteOneByOne');
    this.visibleInviteOneByOne = true;
    this.visibleInviteUploadFile = false;
  }

  showInviteUploadFile () {
    console.log('showInviteFileUpload');
    this.visibleInviteOneByOne = false;
    this.visibleInviteUploadFile = true;
  }

  addInvitation() {
    console.log('addInvitation');
    if (!this.firstname || !this.lastname || !this.email || !this.mobile || !this.validEmail()) {
      return;
    }

    this.listInvitations.push({
      firstname: this.firstname,
      lastname: this.lastname,
      email: this.email,
      mobile: this.mobile,
      idnumber: this.idnumber,
      job_id: this.Job.id
    });

    this.firstname = '';
    this.lastname = '';
    this.email = '';
    this.mobile = '';
    this.idnumber = '';
  }

  removeInvitation(elm) {
    let index = -1;

    for (let _i = 0; _i < this.listInvitations.length; _i++) {
      if (this.listInvitations[_i].email === elm.email
        && this.listInvitations[_i].firstname === elm.firstname
        && this.listInvitations[_i].lastname === elm.lastname
        && this.listInvitations[_i].mobile === elm.mobile
      ) {
        index = _i;
        break;
      }
    }

    if (index > -1) {
      this.listInvitations.splice(index, 1);
    }
  }

  onInvite(){
    if (this.createInvite) {
      this.onPostInvite();
    } else {
      this.onPutInvite();
    }
  }

  onPostInvite() {
    this.addInvitation();

    let invitations = this.listInvitations;

    console.log(invitations);

    this.inviteService.postInvite(invitations)
      .subscribe(
        data => {
          this.publicating = false;
          this.dialogRef.close('yes');
          this.dialog.open(MessageBoxInviteDialog, {data: {data: data, success: true, showIcon:true}});
        },
        error => {
          let txterrors : string = error;
          let jsonErrors : any =  [];
          jsonErrors =  JSON.parse(txterrors);
          jsonErrors = jsonErrors.errors;
          txterrors = '';
          if (jsonErrors.length > 0){
            jsonErrors.forEach(function(element, index) {
                let err: any;
                let txterr: string = "";
                for(err in element.errors){
                  if (element.errors[err][0] !== undefined){
                    txterr = txterr+" "+element.errors[err][0];
                  }
                }
                if (element.row !== undefined) {
                  txterrors = txterrors+"<p class='bg-danger'>"+element.row+" ("+txterr+")</p>";
                } else {
                  txterrors = txterrors+"<p class='bg-danger'>"+""+txterr+"</p>";
                }
                //txterrors = txterrors+"<p class='bg-danger'>"+txterr+"</p>";
            });
          }else{
                txterrors = "<p class='bg-danger'>no hubo errores</p>"
          }
          this.publicating = false;
          this.errorMessage = <any>error

          this.dialog.open(MessageBoxDialog, {data: {title: 'Información Dreamjobs', html: txterrors, alert: true, showIcon: true}});
        }
      );
  }

  onPutInvite() {
  }

  onUploadOutput(output: UploadOutput): void {
    console.log(output); // lets output to see what's going on in the console

    if (output.type === 'allAddedToQueue') { // when all files added in queue
      // uncomment this if you want to auto upload files when added
      const event: UploadInput = {
        type: 'uploadAll',
        url: `${ environment.apiRoot }/invite-csv/`,
        method: 'POST',
        id: this.jobId,
        data: { id: this.jobId },
        headers: {'X-API-KEY': environment.apiKey, 'X-ACCESS-TOKEN': this.auth.idToken},
        concurrency: 0
      };
      this.uploadInput.emit(event);
    } else if (output.type === 'addedToQueue') {
      this.files.push(output.file); // add file to array when added
    } else if (output.type === 'uploading') {
      this.publicating = true;
      // update current data in files array for uploading file
      const index = this.files.findIndex(file => file.id === output.file.id);
      this.files[index] = output.file;
    } else if (output.type === 'removed') {
      // remove file from array when removed
      this.files = this.files.filter((file: UploadFile) => file !== output.file);
    } else if (output.type === 'dragOver') { // drag over event
      this.dragOver = true;
    } else if (output.type === 'dragOut') { // drag out event
      this.dragOver = false;
    } else if (output.type === 'drop') { // on drop event
      this.dragOver = false;
    } else if (output.type === 'done') {
      this.publicating = false;
      this.dialogRef.close('yes');
        if (output.file.response.meta.status == 400){
          this.publicating = false;
          let jsonInvitations: any = [];
          let jsonErrors: any = [];
          let txterrors : string = "";
          let txtinvitations : string = "";
          let txtmessage : string = "";
          if (typeof JSON.parse(output.file.response.meta.message) == 'string'){
            console.log(output.file.response.meta.message);
            txtmessage = output.file.response.meta.message;
          }else{
              jsonErrors =  JSON.parse(output.file.response.meta.message).errors;
              jsonInvitations =  JSON.parse(output.file.response.meta.message).invitations;
              console.log(jsonInvitations);
              console.log(jsonErrors);
              if (jsonErrors.length > 0){
                jsonErrors.forEach(function(element, index) {
                    let err: any;
                    let txterr: string = "";
                    for(err in element.errors){
                      txterr = txterr+" "+element.errors[err][0];
                      console.log(element.errors[err][0]);
                    }
                    txterrors = txterrors+"<p class='bg-danger'>"+element.row+" ("+txterr+")</p>";

                });
              }else{
                txterrors = "<p class='bg-danger'>no hubo errores</p>"
              }
              if (jsonInvitations.length > 0){
                jsonInvitations.forEach(function(element, index) {
                    txtinvitations = txtinvitations+"<p class='bg-success'>"+element.email+"</p>";
                });
              }else{
                txtinvitations = "<p class='bg-info'>no hubo invitados</p>"
              }
              txtmessage = "<p class='bg-info'>Invitados Exitosamente: </p>"+txtinvitations+" <p class='bg-info'> Errores al Invitar a Entrevista Virtual: </p>"+txterrors;
              }
          this.dialog.open(MessageBoxDialog, {data: {title: 'Información Dreamjobs', html: txtmessage, alert: true, showIcon: true}});
        }

        if (output.file.response.meta.status == 422)
          this.dialog.open(MessageBoxDialog, {data: {title: 'Información Dreamjobs', message: output.file.response.meta.message, alert: true, showIcon: true}});

        if (output.file.response.meta.status == 401)
          this.dialog.open(MessageBoxDialog, {data: {title: 'Información Dreamjobs', message: output.file.response.meta.message, alert: true, showIcon: true}});

        if (output.file.response.meta.status == 409)
          this.dialog.open(MessageBoxInviteDialog, {data: {data: output.file.response.data.message, success: true, showIcon:true}});

        if (output.file.response.meta.status == 200)
          this.dialog.open(MessageBoxInviteDialog, {data: {data: output.file.response.data, success: true, showIcon:true}});
    }
  }

  startUpload(): void {  // manually start uploading
    const event: UploadInput = {
      type: 'uploadAll',
      url: `${ environment.apiRoot }/invite/upload`,
      method: 'POST',
      data: { foo: 'bar' },
      concurrency: 1 // set sequential uploading of files with concurrency 1
    }

    this.uploadInput.emit(event);
  }

  cancelUpload(id: string): void {
    this.uploadInput.emit({ type: 'cancel', id: id });
  }

  downloadFileCsv(){
    window.open('../../assets/invitation_example/example.csv');
  }

  downloadFileXlsx(){
    window.open('../../assets/invitation_example/example.xlsx');
  }

  _keyPressNumber(event: any) {
    const pattern = /[0-9\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    // console.log(inputChar, e.charCode);
    if (!pattern.test(inputChar)) {
      // invalid character, prevent input
      event.preventDefault();
    }
  }

  openDialogPaymentCredits() {
    let dialogRef = this.dialog.open(PaymentDialogComponent);
    // dialogRef.afterClosed().subscribe(result => {
    //   this.searchTransactions();
    // });
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/invite/invite.component.ts